// src/pages/SpreadSelection.jsx
import React, { useState } from 'react';
import spreadsData from '../data/spreads-data.json';

const CATEGORY_ICONS = {
  'Amor': '💕',
  'Negocios': '💼',
  'Salud': '🌿',
  'Generales': '🔮',
};

const SpreadSelection = ({ onSelect, onBack, freePremiumUsed, aiStatus }) => {
  const [activeCategory, setActiveCategory] = useState('all');
  const aiOnline = aiStatus === 'online';

  const spreadsByCategory = Object.values(spreadsData).reduce((acc, spread) => {
    const category = spread.category || 'Generales';
    if (!acc[category]) acc[category] = [];
    acc[category].push(spread);
    return acc;
  }, {});

  const categoryOrder = ['Amor', 'Negocios', 'Salud', 'Generales'];
  const allCategories = ['all', ...categoryOrder.filter((c) => spreadsByCategory[c])];

  const getFilteredSpreads = () => {
    if (activeCategory === 'all') {
      return categoryOrder.flatMap((cat) => spreadsByCategory[cat] || []);
    }
    return spreadsByCategory[activeCategory] || [];
  };

  const getButtonConfig = (spread) => {
    const isPaid = spread.price > 0;
    if (!isPaid) return { text: '🌟 Lectura Gratuita', disabled: false, variant: 'free' };
    if (!aiOnline) return { text: 'Oráculo AI no disponible', disabled: true, variant: 'disabled' };
    if (!freePremiumUsed) return { text: '✨ Probar Gratis ✨', disabled: false, variant: 'trial' };
    return { text: `Consultar por $${spread.price.toFixed(2)} USD`, disabled: false, variant: 'paid' };
  };

  return (
    <div className="page-container">
      <div className="spread-page-header">
        <h2 className="page-title font-cinzel">Elige tu Tirada</h2>
        <p className="page-subtitle">
          Cada tirada ofrece una perspectiva diferente. Elige la que más resuene con lo que buscas hoy.
        </p>
      </div>

      {!freePremiumUsed && aiOnline && (
        <div className="free-trial-banner">
          <div className="free-trial-glow"></div>
          <span className="free-trial-badge">🎁 REGALO</span>
          <div className="free-trial-text">
            <strong>¡Tienes 1 lectura premium gratuita!</strong>
            <p>Elige cualquier tirada de pago y experimenta el Oráculo AI sin costo.</p>
          </div>
        </div>
      )}

      {/* Category Filter */}
      <div className="category-filter">
        {allCategories.map((cat) => (
          <button
            key={cat}
            onClick={() => setActiveCategory(cat)}
            className={`category-tab ${activeCategory === cat ? 'category-tab--active' : ''}`}
          >
            {cat === 'all' ? '✦ Todas' : `${CATEGORY_ICONS[cat] || ''} ${cat}`}
          </button>
        ))}
      </div>

      {/* Spreads Grid */}
      <div className="spreads-grid">
        {getFilteredSpreads().map((spread) => {
          const btn = getButtonConfig(spread);
          const isPaid = spread.price > 0;
          return (
            <div
              key={spread.name}
              className={`spread-card ${isPaid ? 'spread-card--premium' : ''} ${btn.disabled ? 'spread-card--disabled' : ''}`}
            >
              <div className="spread-card-header">
                <h3 className="spread-card-title font-cinzel">
                  {spread.name}
                  {isPaid && <span className="spread-ai-badge" title="Potenciado por IA">🔮 AI</span>}
                </h3>
                {isPaid ? (
                  <span className="spread-price-tag">${spread.price.toFixed(2)} USD</span>
                ) : (
                  <span className="spread-price-tag spread-price-tag--free">Gratis</span>
                )}
              </div>

              <p className="spread-card-desc">{spread.description}</p>

              <div className="spread-positions">
                {spread.positions?.slice(0, 3).map((pos, i) => (
                  <span key={i} className="spread-position-chip">{pos}</span>
                ))}
                {spread.positions?.length > 3 && (
                  <span className="spread-position-chip spread-position-chip--more">+{spread.positions.length - 3} más</span>
                )}
              </div>

              <button
                onClick={() => onSelect(spread)}
                disabled={btn.disabled}
                className={`main-button spread-action-btn spread-action-btn--${btn.variant}`}
              >
                {btn.text}
              </button>
            </div>
          );
        })}
      </div>

      <button onClick={onBack} className="main-button secondary-button back-btn">
        ← Volver al Inicio
      </button>
    </div>
  );
};

export default SpreadSelection;
